"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstInputERC20Amount = exports.filterNFTAmountInputs = exports.filterERC20AmountInputs = void 0;
const token_1 = require("./token");
const filterERC20AmountInputs = (inputERC20Amounts, filter) => {
    const erc20AmountsForStep = inputERC20Amounts.filter(filter);
    const unusedERC20Amounts = inputERC20Amounts.filter(erc20Amount => !filter(erc20Amount));
    return { erc20AmountsForStep, unusedERC20Amounts };
};
exports.filterERC20AmountInputs = filterERC20AmountInputs;
const filterNFTAmountInputs = (inputNFTAmounts, filter) => {
    const nftAmountsForStep = inputNFTAmounts.filter(filter);
    const unusedNFTAmounts = inputNFTAmounts.filter(erc20Amount => !filter(erc20Amount));
    return { nftAmountsForStep, unusedNFTAmounts };
};
exports.filterNFTAmountInputs = filterNFTAmountInputs;
const findFirstInputERC20Amount = (inputERC20Amounts, erc20Info) => {
    const inputERC20Amount = inputERC20Amounts.find(erc20Amount => (0, token_1.compareERC20Info)(erc20Amount, erc20Info));
    if (!inputERC20Amount) {
        throw new Error(`First input for this recipe must contain ERC20 Amount: ${erc20Info.tokenAddress}.`);
    }
    return {
        tokenAddress: inputERC20Amount.tokenAddress,
        decimals: inputERC20Amount.decimals,
        amount: inputERC20Amount.expectedBalance,
    };
};
exports.findFirstInputERC20Amount = findFirstInputERC20Amount;
